/**
 * @file ProfileSkeleton.tsx
 * @description
 * -----------------------------------------------------
 * Componente para el skeleton de la página de perfil
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-03-13
 * @modified 2025-06-26
 * @author DLTCode
 * @author Ismael Benabdellah
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
const ProfileSkeleton = () => {
  const $ = _c(12);
  const loading = useTranslations("Loading");
  let t0;
  if ($[0] !== loading) {
    t0 = loading("loading");
    $[0] = loading;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className="profile-skeleton__tabs"><div className="profile-skeleton__tabs__container"><div className="profile-skeleton__tabs__container--tab skeleton" /><div className="profile-skeleton__tabs__container--tab skeleton" /><div className="profile-skeleton__tabs__container--tab skeleton" /></div></section>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="profile-skeleton__content__avatar"><div className="profile-skeleton__content__avatar--img skeleton" /><div className="profile-skeleton__content__avatar--btn skeleton" /></section>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="profile-skeleton__content__info--group"><span className="profile-skeleton__content__info--group__label skeleton" /><span className="profile-skeleton__content__info--group__line skeleton" /></section>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section className="profile-skeleton__content__info--group"><span className="profile-skeleton__content__info--group__label skeleton" /><span className="profile-skeleton__content__info--group__line skeleton" /></section>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <section className="profile-skeleton__content__info--group"><span className="profile-skeleton__content__info--group__label skeleton" /><span className="profile-skeleton__content__info--group__line skeleton" /></section>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <section className="profile-skeleton__content__info--group"><span className="profile-skeleton__content__info--group__label skeleton" /><span className="profile-skeleton__content__info--group__line skeleton" /></section>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <section className="flex__columns">{t3}{t4}{t5}{t6}<section className="profile-skeleton__content__info--group"><span className="profile-skeleton__content__info--group__label skeleton" /><span className="profile-skeleton__content__info--group__line skeleton" /></section></section>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <article className="profile-skeleton__content">{t2}<article className="profile-skeleton__content__info">{t7}<section className="profile-skeleton__content__info--actions"><div className="profile-skeleton__content__info--actions__btn skeleton" /><div className="profile-skeleton__content__info--actions__btn skeleton" /><div className="profile-skeleton__content__info--actions__btn skeleton" /></section></article></article>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t0) {
    t9 = <><section className="profile-skeleton" role="status" aria-live="polite" aria-busy="true" aria-label={t0}>{t1}{t8}</section></>;
    $[10] = t0;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
};
export default ProfileSkeleton;